import { GeoPoint } from "../../Location/Entities";

/** Input field properties */
export interface InputFieldProps {
    label: string;
    value: string;
    name: string;
    isError?: boolean;
    imgSrc?: string;
    type?: InputTypes;
    location?: GeoPoint;
    placeholder?: string;
    onAddressChosen?: (address: string) => void;
    updateHandler?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    labelForPhoneNumber?: string;
    doesInputHaveValue?: boolean;
    clearTextHandler?: (name: string) => void;
    onCleared?: () => void;
}

/** Accepted types for input fields */
export enum InputTypes {
    Phone = "phone",
    Text = "text",
    Number = "number",
    Address = "address",
}
